module.exports = __webpack_public_path__ + "static/img/avatar_comment_default.d822bfaa.png";